export const API_URL = process.env.REACT_APP_BAROJ_API_URL; //'http://18.222.184.65';
export const API_KEY = process.env.REACT_APP_BAROJ_API_KEY; //'';
export const HEIGHT_RATO = parseInt(process.env.REACT_APP_BAROJ_HEIGHT_RATO ?? "617"); // has no effect
export const NUMBER_OF_RESULTS = parseInt(process.env.REACT_APP_BAROJ_NUMBER_OF_RESULTS ?? "12");
export const MAX_QUERY_LENGTH = parseInt(process.env.REACT_APP_BAROJ_MAX_QUERY_LENGTH ?? "1000");
export const MAX_INTERESTED_IN = parseInt(process.env.REACT_APP_BAROJ_MAX_INTERESTED_IN ?? "30");